import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '../routes/route.paths';
import { AuthentificationService } from '@core/services/authentification/authentification.service';

export const loginGuard: CanActivateFn = () => {
  const authentificationService = inject(AuthentificationService);
  const router = inject(Router);
  if (authentificationService.isLoggedIn()) {
    router.navigateByUrl(AppRoutes.Welcome);
  }
  return true;
};
